import { takeLatest, put, select, call } from 'redux-saga/effects';

import toaster from '@giro/shared-store/toaster';
import auth from '@giro/shared-store/auth';

import dialogData from '.';

import postDispatchService from '@giro/shared-services/reports/getApiPdvSlipDetailsReports.service';
import postApiDebtsExternalIdService from '@giro/shared-services/debts/postApiDebtsExternalId.service';
import clients from '@giro-pdv/modules/pdv/store/clients';
import { useSelector, useDispatch } from 'react-redux';

import { segmentNormalizeInvertConstant } from '@giro-pdv/constants/segmentNormalize.constant';

function* handleServicePost(action) {
  const { payload } = action;
  const { boleto } = payload.data;

  yield put(dialogData.action.fetchStart());
  const selectorClientsPdv = useSelector(clients.selector.selectState);

  const payloadFormatted = {
    destination: payload.destination,
    type: payload.type,
    subtype: payload.subtype,
    data: {
      codigo_barras: payload.data.codigo_barras,
      descricao: payload.data.descricao,
      nosso_numero: payload.data.nosso_numero,
      enviado_por: selectorClientsPdv?.payload?.nmFantasia,
    },
    attachment: boleto,
  };

  try {
    const [success, data] = yield call(() => postDispatchService(payload));

    if (!success) {
      throw data;
    }

    if (success) {
      yield put(dialogData.action.fetchSuccess(data));
      yield put(
        toaster.action.show({
          message: 'Boleto enviado com sucesso!',
          variant: 'success',
        })
      );
    }
  } catch (error) {
    yield put(dialogData.action.fetchError());
  }
}

function* handleSetOpen(action) {
  const { payload } = action;

  try {
    yield put(dialogData.action.fetchStart());
    yield put(dialogData.action.updateReferenceId(payload));
    const [success, data] = yield call(() => postDispatchService(payload));

    yield put(dialogData.action.fetchSuccess(payload));
  } catch (error) {
    yield put(dialogData.action.fetchError());
  }
}

function* watch() {
  yield takeLatest(dialogData.constant.ACTION_TYPES.SET.OPEN, handleSetOpen);
}

export default {
  watch,
};
